import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { clsx } from "clsx/lite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faHouse } from "@fortawesome/pro-regular-svg-icons";
import { useIsTablet } from "@/config/hooks";
import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import PspLogo from "@/components/pspLogo/PspLogo";
import PspButton from "@/components/pspButton/PspButton";

export function NotFound404() {
  const isTablet = useIsTablet();
  const navigate = useNavigate();
  const { lang } = useContext(PspContext);

  return (
    <div
      className={clsx(
        "h-screen",
        "w-screen",
        "flex",
        "flex-col",
        "items-center",
        "bg-canvas-primary",
        "text-font-black",
        "px-6",
        "py-10",
      )}
    >
      <PspLogo width={isTablet ? 48 : 40} />

      <div className="flex flex-1 flex-col items-center justify-center gap-8 text-center max-w-xl">
        <div className="relative flex items-center justify-center">
          <span
            className={clsx(
              "font-black",
              "leading-none",
              "tracking-tighter",
              "text-primary-50",
              "select-none",
              isTablet ? "text-[12rem]" : "text-[8rem]",
            )}
          >
            404
          </span>
        </div>

        <div className="flex flex-col gap-3">
          <h1 className={clsx("font-bold", isTablet ? "text-3xl" : "text-2xl")}>
            {translate("siteNotFound", lang)}
          </h1>
          <p className="text-font-secondary">
            {translate("siteNotFoundInfo", lang)}
          </p>
        </div>

        <div
          className={clsx(
            "flex",
            "gap-3",
            "w-full",
            isTablet ? "flex-row justify-center" : "flex-col-reverse",
          )}
        >
          <PspButton
            size="large"
            onClick={() => navigate(-1)}
            icon={<FontAwesomeIcon icon={faArrowLeft} />}
          >
            {translate("back", lang)}
          </PspButton>
          <PspButton
            size="large"
            appearance="primary"
            onClick={() => navigate("/")}
            icon={<FontAwesomeIcon icon={faHouse} />}
          >
            {translate("backToHome", lang)}
          </PspButton>
        </div>
      </div>
    </div>
  );
}
